module.exports = "<p>\n  htc-ltc-rec--form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--form/htc-ltc-rec--form.component.html
// module id = ./src/app/hrms/employee-claims/htc-ltc-rec/htc-ltc-rec--form/htc-ltc-rec--form.component.html
// module chunks = main